import * as React from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { DemandeRetour, Item, TauxGestion } from './iMonCompte';
import {
  inputColorWhenError,
  inputColorWhenNoError,
  renderAlert,
  renderCol,
  renderFilArianne,
  renderInput,
  renderTitleH1,
} from './RenderCommon';
import {
  formatPrice,
  getCgvLink,
  getHeadersToken,
  getShopDomainInStorage,
  getShopRefInStorage,
  getUserId,
  sessionExpire,
} from './MonCompteAction';

import { RenderCartLine } from './RenderCartLine';
import { getHostApi, getRequestConfig, initEvent } from '../../utils';
import Modal from 'react-responsive-modal';

interface RenderReclamationState {
  orderId: number;
  showAlert: boolean;
  textAlert: string;
  classAlert: string;
  selectedMotif: any[];
  selectedMotifId: string;
  selectedMotifType: string;
  selectedAttente: string;
  demandesRetour: DemandeRetour;
  item?: Item;
  totalArticlesRetour: number;
  file?: File;
  fileName?: string;
  managementFees: boolean;
  showManagementFees: boolean;
  remboursementHT: number;
  fraisGestion: number;
  totalHT: number;
  totalTTC: number;
  valuesInput: any;
  societe: string;
  retourPossible: boolean;
  items: any[];
  quantites: any[];
  checkedBoxFraisGestion: string;
  tauxGestion?: TauxGestion;
  formValidate: boolean;
  numCommande?: string;
  commentaire: string;
  loading: boolean;
  operateurName?: string;
  operateurId?: string;
  open: boolean;
  src: string;
}

export default class RenderReclamation extends React.Component<Record<string, unknown>, RenderReclamationState> {
  constructor(props: any) {
    super(props);
    this.state = {
      orderId: props.match.params.id,
      showAlert: false,
      textAlert: 'Votre demande de réclamation a bien été annulée',
      classAlert: 'alert-success',
      selectedMotif: [],
      selectedMotifId: '',
      selectedMotifType: 'retour',
      selectedAttente: '0',
      demandesRetour: {
        attentesClient: [],
        items: [],
        motifs: [],
        nbArticlesCmd: 0,
        tauxTva: '0',
        prixTva: '0',
      },
      totalArticlesRetour: 0,
      managementFees: false,
      showManagementFees: false,
      remboursementHT: 0,
      fraisGestion: 0,
      totalHT: 0,
      totalTTC: 0,
      valuesInput: {},
      societe: '',
      retourPossible: false,
      items: [],
      quantites: [],
      checkedBoxFraisGestion: '0',
      formValidate: false,
      commentaire: '',
      loading: false,
      open: false,
      src: '',
    };
  }

  componentWillMount() {
    this._getOperateur();
    this._getDemandes();
    this._checkRetour();
    this._getTauxGestion();
  }

  _getOperateur() {
    document.dispatchEvent(initEvent('dp-loading'));
    axios.get(`${getHostApi()}/customers/${getUserId()}`, getRequestConfig())
      .then((response) => {
        document.dispatchEvent(initEvent('dp-loaded'));
        if (response.data.customer) {
          this.setState({
            operateurName: response.data.customer.operateur.nom,
            operateurId: response.data.customer.operateur.id,
          });
        }
      }).catch((error) => {
      document.dispatchEvent(initEvent('dp-loaded'));
      if (error.response && error.response.status && error.response.status === 401) {
        sessionExpire();
      }
    });
  }

  /**
   * Fonction permettant de retourner toutes les demandes de réclamation pour une commande
   *
   * @private
   */
  _getDemandes = () => {
    document.dispatchEvent(new Event('dp-loading'));
    axios.get(`${getHostApi()}/customers/${getUserId()}/orders/${this.state.orderId}/reclamations/data`,
      getRequestConfig()).then((response) => {
      document.dispatchEvent(new Event('dp-loaded'));
      if (response.data.demandeRetour) {
        this.setState({ demandesRetour: response.data.demandeRetour }, () => {
          this._defineNumCommande();
        });
      }
    }).catch((error) => {
      document.dispatchEvent(new Event('dp-loaded'));
      if (error.response.status === 401) {
        sessionExpire();
      }
    });
  }

  /**
   * Fonction permettant de vérifier si la demande de réclamation est sujette à des frais de gestion
   *
   * @param {any[]} items
   * @private
   */
  _checkManagementFees = (items: any[]) => {
    axios.post(
      `${getHostApi()}/customers/${getUserId()}/orders/${this.state.orderId}/reclamations/management-fees`,
      {
        nbArticlesCmd: this.state.demandesRetour.nbArticlesCmd, Societe: this.state.societe,
        motifType: this.state.selectedMotifType,
      },
      getRequestConfig()).then((response) => {
        if (this.state.checkedBoxFraisGestion === '1') {
          this.setState({
            managementFees: false,
            showManagementFees: true,
          }, () => {
            this._getMontantRemboursement(items);
          });
        } else {
          this.setState({
            managementFees: response.data.frais_gestion,
            showManagementFees: response.data.frais_gestion,
          }, () => {
            this._getMontantRemboursement(items);
          });
        }
      }).catch((error) => {
        console.log(error);
      });
  }

  /**
   * Fonction retournant le taux de frais de gestion enregistré dans les variables en BO
   *
   * @private
   */
  _getTauxGestion = () => {
    axios.get(
      `${getHostApi()}/customers/${getUserId()}/orders/${this.state.orderId}/reclamations/variables/retour_sav`,
      getRequestConfig()).then((response) => {
        this.setState({ tauxGestion: response.data.taux_gestion });
      }).catch((error) => {
        console.log(error);
      });
  }

  /**
   * Fonction retournant les montants HT et TTC du remboursement avec les frais de gestion
   *
   * @param {any[]} items
   * @private
   */
  _getMontantRemboursement = (items: any[]) => {
    axios.post(
      `${getHostApi()}/customers/${getUserId()}/orders/${this.state.orderId}/reclamations/refunding-amount`,
      { items: items, frais_gestion: this.state.managementFees },
      getRequestConfig()).then((response) => {
        if (response.data.remboursement) {
          this.setState({
            remboursementHT: response.data.remboursement.remboursementHT,
            fraisGestion: response.data.remboursement.fraisGestion,
            totalHT: response.data.remboursement.totalRemboursementHT,
            totalTTC: response.data.remboursement.totalRemboursementTTC,
          });
        }
      }).catch((error) => {
        console.log(error);
      });
  }

  /**
   * Fonction vérifiant si le retour est possible
   *
   * @private
   */
  _checkRetour = () => {
    axios.get(
      `${getHostApi()}/customers/${getUserId()}/orders/${this.state.orderId}/reclamations/is-possible`,
      getRequestConfig()).then((response) => {
        if (response.data.retour_possible) {
          this.setState({ retourPossible: response.data.retour_possible });
        }
      }).catch((error) => {
        console.log(error);
      });
  }

  _createFormData = () => {
    const formData = new FormData();
    const quantites = this._createQuantitesState(this.state.items);

    let fraisGestion = '0';
    if (this.state.managementFees) {
      fraisGestion = '1';
    }

    formData.append('quantites', JSON.stringify(quantites));
    formData.append('commentaire', JSON.stringify(this.state.commentaire));
    formData.append('motifIndex', this.state.selectedMotifId);
    formData.append('fraisGestion', fraisGestion);
    formData.append('attenteClient', this.state.selectedAttente);
    formData.append('file', this.state.file as any);

    /* if (this.state.operateurId) {
      formData.append('operateurId', this.state.operateurId);
    } */

    return formData;
  }

  /**
   * Fonction créant la demande de retour
   *
   * @private
   */
  _createRetour = () => {
    const headers = getHeadersToken();
    headers['Content-Type'] = 'multipart/form-data';

    this.setState({
      loading: true,
    });

    axios.post(
      `${getHostApi()}/customers/${getUserId()}/orders/${this.state.orderId}/reclamations/`,
      this._createFormData(),
      {headers: headers, ...getRequestConfig()}).then((response) => {
        if (response.data.errors) {
          this.setState({
            showAlert: true,
            textAlert: response.data.errors,
            classAlert: 'alert-danger',
            loading: false,
          });
        } else {
          this.setState({
            showAlert: true,
            textAlert: 'Votre demande a bien été prise en compte.',
            classAlert: 'alert-success',
            formValidate: true,
            loading: false,
          });
        }
      }).catch((error) => {
        console.log(error);
        this.setState({
          showAlert: true,
          textAlert: error.response.data.message,
          classAlert: 'alert-danger',
          loading: false,
        });
      });
  }

  _defineNumCommande = () => {
    this.setState({
      numCommande: this.state.demandesRetour.items[0].numCmd,
    });
  }

  _handleChangeMotif = (event: React.ChangeEvent<HTMLSelectElement>) => {
    if (event.target.value != '') {
      this.setState({
        selectedMotifId: event.target.value,
      }, () => {
        this._createSelectedMotifState();
      });
    }
  }

  _handleChangeAttente = (event: React.ChangeEvent<HTMLSelectElement>) => {
    if (event.target.value !== '0') {
      this.setState({
        selectedAttente: event.target.value,
      });
    }
  }

  /**
   * Fonction mettant à jour les quantités saisies pour chaque ligne panier
   *
   * @param {any[]} items
   * @returns {any}
   * @private
   */
  _createQuantitesState = (items: any[]) => {
    const tab: any = {};
    for (const item of items) {
      tab[item.panier_id] = item.quantite;
    }

    return tab;
  }

  /**
   * Fonctioin mettant à jour le motif sélectionner par l'utilisateur
   *
   * @private
   */
  _createSelectedMotifState = () => {
    const motifs = this.state.demandesRetour.motifs;
    const tabSelectedMotifs: any = [];
    let i = 0;

    for (const motif of motifs) {
      // tabSelectedMotifs[motif.id] = motif.type;
      tabSelectedMotifs[i] = motif.type;
      i++;
    }

    this.setState({
      selectedMotif: tabSelectedMotifs,
    }, () => {
      this._createSelectedMotifTypeState();
    });
  }

  /**
   * Fonction mettant à jour le type de motif sélectionné par l'utilisateur
   *
   * @private
   */
  _createSelectedMotifTypeState = () => {
    const motifs = this.state.selectedMotif;
    const motif = this.state.selectedMotifId;
    let type = this.state.selectedMotifType;

    motifs.forEach((value: string, index: number) => {
      if (String(index) === motif) {
        type = value.toLowerCase();
      }
    });

    this.setState({
      selectedMotifType: type,
    }, () => {
      this._calculMontantsRemboursement();
    });
  }

  /**
   * Fonction mettant à jour les montants affichés à l'utilisateur pour sa demande de remboursement
   *
   * @private
   */
  _calculMontantsRemboursement = () => {
    const items: any[] = [];
    let quantite;
    let totalArticlesRetour = 0;

    for (const item of this.state.demandesRetour.items) {
      if (item.quantiteImpactee) {
        quantite = item.quantiteImpactee;
      } else {
        quantite = '0';
      }

      items.push({ quantite: quantite, panier_id: item.idCaddies });
      totalArticlesRetour += Number(quantite);

      this.setState({
        societe: item.Societe,
        totalArticlesRetour: totalArticlesRetour,
      });
    }

    this.setState({
      items: items,
    }, () => {
      this._checkManagementFees(items);
    });
    // this._getMontantRemboursement(items);
  }

  _onChangeCommentaire = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    this.setState({ commentaire: event.target.value });
  }

  _onUpdateInput = (event: React.ChangeEvent<HTMLInputElement>, index: number | null = null) => {
    if (event.target.type === 'file') {
      this.setState({
        file: event.target.files?.[0],
        fileName: event.target.value,
      });
    } else if (event.target.type === 'checkbox') {
      const value = (event.target.checked) ? '1' : '0';
      this.setState({
        checkedBoxFraisGestion: value,
      }, () => {
        this._calculMontantsRemboursement();
      });
    } else {
      const values = { ...this.state.demandesRetour };
      values.items[index as number].quantiteImpactee = event.target.value;

      this.setState({
        demandesRetour: values,
      }, () => {
        this._calculMontantsRemboursement();
      });
    }
  }

  _onItemQuantiteChanged = (item: Item, quantite: string) => {
    const retour = { ...this.state.demandesRetour };
    const index = retour.items.indexOf(item);
    retour.items[index].quantiteImpactee = quantite;

    this.setState({
      demandesRetour: retour,
    }, () => {
      this._calculMontantsRemboursement();
    });
  }

  /**
   * Fonction permettant de cacher les alerts sur la page
   *
   * @private
   */
  _hideAlert = () => {
    this.setState({
      showAlert: false,
    });
  }

  _emptyInputQuantityColor = () => {
    for (const item of this.state.demandesRetour.items) {
      document.getElementsByName(item.idCaddies).item(0).style.borderColor = 'red';
    }
  }

  _inputQuantityColor = () => {
    for (const item of this.state.demandesRetour.items) {
      document.getElementsByName(item.idCaddies).item(0).style.borderColor = '#bbb';
    }
  }

  /**
   * Fonction vérifiant les quantités saisies par l'utilisateur
   *
   * @private
   */
  _checkQuantity = () => {
    this._inputQuantityColor();

    if (this.state.totalArticlesRetour === 0) {
      this.setState({
        showAlert: true,
        textAlert: 'Veuillez saisir des quantités valides à retourner !',
        classAlert: 'alert-danger',
      });
      this._emptyInputQuantityColor();
    } else {
      this._createRetour();
    }
  }

  /**
   * Fonction vérifiant les quantités saisies par l'utilisateur
   *
   * @private
   */
  _checkMultipleMin = () => {
    for (const item of this.state.demandesRetour.items) {
      const isMultipleInitial = parseInt(item.Quantite) % item.multipleMin;
      const isMultiple = parseInt(item.quantiteImpactee) % item.multipleMin;
      if (isMultipleInitial == 0 && isMultiple != 0 && item.quantiteImpactee &&  item.multipleMin && parseInt(item.quantiteImpactee) != 0 && item.multipleMin > 0) {
        document.getElementsByName(item.idCaddies).item(0).style.borderColor = 'red';
        this.setState({
          showAlert: true,
          textAlert: 'Cet article nécessite d\'être retourné par multiple de ' + item.multipleMin,
          classAlert: 'alert-danger',
        });
        return false;
      }
    }
    this._checkQuantity();
  }

  /**
   * Fonctin permettant de vérifier la validité des champs du formulaire
   *
   * @param {React.MouseEvent<HTMLButtonElement>} event
   * @private
   */
  _isValidForm(event: React.MouseEvent<HTMLButtonElement>) {
    event.preventDefault();
    this._hideAlert();
    inputColorWhenNoError('selectMotif');
    inputColorWhenNoError('file');
    inputColorWhenNoError('selectAttente');

    // if (!this.state.operateurName) {
      if (this.state.selectedMotifId !== '') {
        if ((this.state.demandesRetour.motifs as any)[this.state.selectedMotifId].justificatif_photo == 1 &&
          !this.state.fileName) {
          this.setState({
            showAlert: true,
            textAlert: 'Veuillez joindre la photo justifiant votre demande.',
            classAlert: 'alert-danger',
          });
          inputColorWhenError('file');
        } else {
          if (this.state.selectedAttente === '0') {
            this.setState({
              showAlert: true,
              textAlert: 'Veuillez sélectionner votre attente',
              classAlert: 'alert-danger',
            });
            inputColorWhenError('selectAttente');
          } else {
            if (this.state.selectedMotifType == 'retour') {
              this._checkMultipleMin();
            } else {
              // this._checkRetour();
              this._checkQuantity();
            }
          }
        }
      } else {
        this.setState({
          showAlert: true,
          textAlert: 'Veuillez sélectionner un motif',
          classAlert: 'alert-danger',
        });
        inputColorWhenError('selectMotif');
      }
    /* } else {
      this._createRetour();
    } */

  }

  onOpenImageModal = (lien: any) => {
    this.setState({ open: true, src: lien });
  };

  onCloseImageModal = () => {
    this.setState({ open: false });
  };

  render() {

    const renderMotifs = () => {
      const { demandesRetour } = this.state;
      const { motifs, items } = demandesRetour;
    
      const filteredMotifs = motifs.filter(motif => {
        if (parseInt(motif.inactif) !== 0) return false;
        return items.some(item => motif.marquages.includes(item.marquage_id ?? 0));
      });
    
      return (
        <div className="d-flex flex-row align-items-center motifs-reclamation">
          <div className="pr-3 col-12 col-md-6 col-xl-5 pl-0 pa0Mobile">
            <select value={this.state.selectedMotifId} onChange={this._handleChangeMotif} name="selectMotif">
              <option value="">--- Motif ---</option>
              {filteredMotifs.map((motif, i) => (
                <option key={motif.id} value={i} id={motif.type}>{motif.libelle}</option>
              ))}
            </select>
          </div>
          <div className="col-12 col-md-6 col-xl-7 p-0">
            &nbsp;
          </div>
        </div>
      );
    };

    const renderCommentaire = () => {
      const caracteresRestant = 140 - this.state.commentaire.length;
      let classAlert = '';

      if (caracteresRestant == 0) {
        classAlert = 'red';
      } else {
        classAlert = '';
      }

      if (this.state.selectedMotifType === 'reclamation') {
        return (
          <div className={'p-0 mb-3 '}>
            <textarea className="w-100 textareaReclamation" placeholder="Indiquez-nous ici le problème rencontré ..."
                      maxLength={140} onChange={e => this._onChangeCommentaire(e)}></textarea>
            <div>
              <p className={'text-right grey pt-2 ' + classAlert}>Caractères restants : {caracteresRestant}/140</p>
            </div>
          </div>
        );
      }
    };

    const renderLegend = () => {
      const ref = getShopRefInStorage();
      const legendPhoto = ref == 'DT' ? 'Visuel' : 'Photo';
      const sizeCol = ref == 'DT' ? '12' : '5';
      return (
        <div className={'d-flex flex-row justify-content-between border-bottom bg-black white mt-5 py-1' +
        ' legendReclamation'}>
          {renderCol(legendPhoto, '1 col-lg-1 p-0')}
          <div className="d-flex align-items-center col-md-7 p-0 pl-1">
            {renderCol('Description', sizeCol)}
            {ref != 'DT' &&
            <>
              {renderCol('Référence', '3 p-0')}
              {renderCol('Couleur', '2')}
              {renderCol('Taille', '2')}
            </>
            }
          </div>
          <div className="d-flex align-items-center col-md-4 p-0 pr-1">
            {renderCol('Quantité impactée', '8 col-lg-7 p-0')}
            {renderCol('P.U H.T', '4 col-lg-5 pr-0')}
          </div>
        </div>
      );
    };

    const renderImageModal = () => {
      const ref = getShopRefInStorage();
      let classAlpha = '';
      if(ref == 'DT') {
        classAlpha = 'bg-alpha';
      }
      const { open, src } = this.state;
      return (
          <div>
            <Modal classNames={{overlay: 'bootstrap-container'}} open={open} onClose={this.onCloseImageModal} center>
              <div className={'text-center'}>
                <div className={classAlpha}>
                  <img src={src} className={'img-fluid'}/>
                </div>
              </div>
            </Modal>
          </div>
      );
    };

    const renderListItems = this.state.demandesRetour.items.map((item: Item, index: number) => {
      const motif = (this.state.demandesRetour.motifs as any)[this.state.selectedMotifId];
      return (
        <div key={item.idCaddies} className="row-item pt-3 pb-3 border position-relative">
          <RenderCartLine onQuantiteChange={this._onItemQuantiteChanged} onOpenImageModal={this.onOpenImageModal} item={item} motif={motif} />
        </div>
      );
    });

    const renderTableItems = () => {
      return (
        <div>
          {renderLegend()}
          {renderListItems}
          {renderImageModal()}
        </div>
      );
    };

    const renderTextFileUpload = () => {
      const motif = (this.state.demandesRetour.motifs as any)[this.state.selectedMotifId];

      if (motif && motif.justificatif_photo == '1') {
        return (
          <div>
            <p className="m-0 font-weight-bold">
              Veuillez envoyer une photo au format .jpg représentative du problème rencontré : </p>
          </div>
        );
      }
    };

    const renderFileUpload = () => {
      const motif = (this.state.demandesRetour.motifs as any)[this.state.selectedMotifId];

      if (motif && motif.justificatif_photo == '1') {
        return (
          <div className="containerFileUpload containerFileUploadReclamation">
            {renderInput('file', 'file', this.state.fileName, this._onUpdateInput, getShopRefInStorage() === 'TH' ? 'uploadTHSav' : '')}
          </div>
        );
      }
    };

    const renderOptionsAttentes = () => {
      const tabAttentes = [];
      tabAttentes.push(<option value="0">--- Votre attente ---</option>);

      const motif = (this.state.demandesRetour.motifs as any)[this.state.selectedMotifId];
      if (motif.remplacement != '0') {
        tabAttentes.push(<option value="Remplacement">Remplacement</option>);
      }

      if (motif.remboursement != '0') {
        tabAttentes.push(<option value="Remboursement">Remboursement</option>);
      }

      return tabAttentes;
    };

    const renderTotalArticlesImpactes = () => {
      return (
        <div>
          <p className="m-0 text-right">
            Votre demande concerne {this.state.totalArticlesRetour} article(s) </p>
        </div>
      );
    };

    const renderSelectAttente = () => {
      if (this.state.selectedMotifId !== '') {
        return (
          <div className="mt-2">
            <select value={this.state.selectedAttente} id={this.state.selectedAttente}
                    onChange={this._handleChangeAttente} name="selectAttente">
              {renderOptionsAttentes()}
            </select>
          </div>
        );
      }
    };

    const renderFileAndAttente = () => {
      return (
        <div className="d-flex flex-row justify-content-between col-md-12 my-3 p-0 reclamFile">
          <div className="col-md-6 col-12 p-0">
            {renderTextFileUpload()}
            {renderFileUpload()}
          </div>
          <div className="col-md-6 col-12 text-right p-0">
            {renderTotalArticlesImpactes()}
            {renderSelectAttente()}
          </div>
        </div>
      );
    };

    const renderRemboursementHT = () => {
      if (this.state.managementFees) {
        return (
          <div className="d-flex flex-row align-items text-right">
            <p className="col-md-10 col-9 mb-0 p-0">Remboursement HT :</p>
            <p className="col-md-2 col-3 mb-0 pr-0">{formatPrice(String(this.state.remboursementHT))} &euro;</p>
          </div>
        );
      }
    };

    const renderFraisGestion = () => {
      if (this.state.managementFees) {
        // if (true) {
        return (
          <div className="d-flex flex-row align-items text-right">
            <p className="col-md-10 col-9 mb-0 p-0">Frais de gestion <sup>(1)</sup> :</p>
            <p className="col-md-2 col-3 mb-0 pr-0">- {formatPrice(String(this.state.fraisGestion))} &euro;</p>
          </div>
        );
      }
    };

    const renderTotalRemboursementHT = () => {
      return (
        <div className="d-flex flex-row align-items text-right">
          <p className="col-md-10 col-9 mb-0 p-0">Montant total HT du remboursement :</p>
          <p className="col-md-2 col-3 mb-0 pr-0">{formatPrice(String(this.state.totalHT))} &euro;</p>
        </div>
      );
    };

    const renderTVA = () => {
      if (this.state.demandesRetour.tauxTva != '0.00') {
        const prixTva = this.state.totalHT * Number(this.state.demandesRetour.tauxTva) / 100;
        return (
          <div className="d-flex flex-row align-items text-right">
            <p className="col-md-10 col-9 mb-0 p-0">TVA à {formatPrice(this.state.demandesRetour.tauxTva)}% :</p>
            <p className="col-md-2 col-3 mb-0 pr-0">{formatPrice(String(prixTva.toFixed(2)))} &euro;</p>
          </div>
        );
      }
    };

    const renderTotalRemboursementTTC = () => {
      return (
        <div className="d-flex flex-row align-items bold text-right">
          <p className="col-md-10 col-9 mb-0 p-0">Montant total TTC du remboursement :</p>
          <p className="col-md-2 col-3 mb-0 pr-0">{formatPrice(String(this.state.totalTTC))} &euro;</p>
        </div>
      );
    };

    const renderTotalRemboursement = () => {
      if (this.state.selectedAttente === 'Remboursement' && this.state.totalArticlesRetour != 0) {
        return (
          <div className="border font14 mb-3 p-2 d-flex flex-column">
            {renderRemboursementHT()}
            {renderFraisGestion()}
            {renderTotalRemboursementHT()}
            {renderTVA()}
            {renderTotalRemboursementTTC()}
          </div>
        );
      }
    };

    const renderAideFraisGestion = () => {
      if (this.state.managementFees) {
        return (
            <div>
              <p>
                <sup>(1)</sup> Frais de gestion de {this.state.tauxGestion?.retour_sav_pourcentage_frais_gestion}%.
                               Pour plus d'informations, consultez nos&nbsp;
                <a href={'https://www.' + getShopDomainInStorage() + '/' + getCgvLink() + '.php'} className="colorbox"
                   target="_blank">C.G.V.</a>
              </p>
            </div>
        );
      }

      return (
          <div>
            <p>

            </p>
          </div>
      );
    };

    const renderConditionFraisGestion = () => {
      if (this.state.showManagementFees && this.state.selectedAttente === 'Remboursement') {
        return (
          <div className="col-md-12">
            {renderAideFraisGestion()}
            {renderchecboxFraisGestion()}
          </div>
        );
      }
    };

    const renderchecboxFraisGestion = () => {
      if (this.state.societe == '') {
        return (
          <div className="col-md-12 d-flex pl-0">
            <div className="d-flex p-0">
              <span className="containerCheckboxGestion p-0">
                {renderInput('checkbox', 'chexboxFraisGestion', this.state.checkedBoxFraisGestion, this._onUpdateInput)}
              </span>
              <p className="col-md-11 p-0">
                Je déclare ne pas représenter une société ou une auto-entreprise, c'est pourquoi en tant que particulier
                et, conformément à l'article L121-20, je demande l'éxonération des frais de gestion. J'ai conscience
                qu'une fausse information peut déclencher une enquête liée à ma demande. </p>
            </div>
          </div>
        );
      }
    };

    const renderButtonValidate = () => {
      return (
        <div className="text-right">
          <div>
            <button disabled={this.state.loading} onClick={this._isValidForm.bind(this)}
                    className="cursor-pointer border border-dark py-2 px-3 bg-white buttonValidateRetour">
              {this.state.loading ? (
                <span>Envoi de la demande...</span>
              ) : (
                <span>Valider ma demande</span>
              )}
            </button>
          </div>
        </div>
      );
    };

    const displayPage = () => {
      if (this.state.retourPossible && this.state.formValidate === false) {
        return (
          <div>
            {renderMotifs()}
            {renderTableItems()}
            {renderFileAndAttente()}
            {renderTotalRemboursement()}
            {renderConditionFraisGestion()}
            {renderAlert(this.state.showAlert, this.state.classAlert, this.state.textAlert)}
            {renderCommentaire()}
            {renderButtonValidate()}
          </div>
        );
      }
      if (!this.state.retourPossible && this.state.formValidate === false) {
        return (
          <div>
            <p className="bold text-center font14 mt7 mt-5">
              Vous ne pouvez plus faire de retour pour cette commande. </p>
          </div>
        );
      }
      return (
        <div className="text-center">
          <p>
            Votre demande sera étudiée par nos services qui vous contacteront très prochainement par email. </p>
          <p className="font16">
            Revenir vers "<Link className="blue" to={`/orders`}>Mes commandes</Link>". </p>
        </div>
      );
    };

    const defineTitleH1 = () => {
      if (getShopRefInStorage() === 'MT') {
        return 'Mes retours / réclamations';
      }

      return 'Mes réclamations';
    };

    const defineArianne = () => {
      if (getShopRefInStorage() === 'MT') {
        return 'retour / réclamation';
      }

      return 'réclamation';
    };

    return (
      <div>
        <div>
          {renderTitleH1('colis', defineTitleH1())}
        </div>
        {renderFilArianne(<Link className="grey" to={`/orders`}>Mes commandes</Link>,
          'Demande de ' + defineArianne() + ' pour la commande n°' + this.state.numCommande)}
        {displayPage()}
      </div>
    );
  }
}
